function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import 'fast-text-encoding';
import { DeviceType, checkIsTizenVersion, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { ShakaPlayerVersion } from '../../config/internal-config';
import { CoreVideoInternal } from '../../core-video-internal';
import { BasePlayerEngineItem, TimedMetadataType } from '../../core/player/player-engine-item';
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { PlayerState } from '../../core/player/player-state';
import { PlayerType } from '../../core/player/player-type';
import { DrmType } from '../../core/player/playout-data';
import { CvsdkError, ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
import { isEdgeDesktop, isSafariDesktop, isWindows, isSafariMobile, isSafariMajorVersion } from '../../utils/device-type';
import { isOldWebOs } from '../../utils/device-webos';
import { JsonUtils } from '../../utils/json-utils';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../utils/playback-type';
import { allSettled } from '../../utils/promise-utils';
import { SafariMetadataManager } from './safari-metadata-manager';
import { ShakaPlayerEngineItemPrecursor } from './shaka-player-engine-item-precursor';
import { ShakaPlayerEngineSeeker } from './shaka-player-engine-seeker';
import { ShakaPlayerEngineSubtitles } from './shaka-player-engine-subtitles';
import { ShakaStateMachineManager } from './shaka-state-machine';
import { ShakaAudioTracksManager } from './shaka-audio-tracks-manager';
import { getTracksConfig } from './configuration/tracks-config';
import { getTimeUpdateConfig } from './configuration/timeupdate-config';
import { SafeInterval } from '../../utils/safe-interval';
import { MINIMUM_VERSION_FOR_MEDIA_QUALITY_CHANGED_EVENT, isVersionCompliant } from './shaka-version-utils';
import { ShakaPlayerError } from './shaka-player-error';
import { getSeekerConfig } from './configuration/seeker-config';
import { SimpleTimer } from '../../utils/simple-timer';
import { ShakaTextTracksManager } from './shaka-text-tracks-manager';
import { SafariShakaTextTracksManager } from './safari-shaka-text-tracks-manager';
import { AudioRole } from '../../core/player/role';
import { getPreferredTrackFromMetadata } from '../../utils/select-track';
import { getTextContents } from '../../utils/dom';
import { getScte35String } from '../../utils/dash-scte35-extractor';
import { stringOrUint8ToString } from '../../utils/utf8Utils';
var TIME_UPDATE_DEFAULT_INTERVAL_MS = 333;
var SAFARI_NATIVE_SUBTITLES_STYLE_ID = 'cvsdk-disabling-safari-native-subtitles';
var SAFARI_NATIVE_SUBTITLES_STYLE_CONTENT = 'video::-webkit-media-text-track-container { display: none; } video::-webkit-media-text-track-background { display: none; } video::-webkit-media-text-track-display { display: none; }';
var AUTOPLAY_NOT_ALLOWED_ERROR_NAME = 'NotAllowedError';
// This is typically the error name for autoplay errors, see https://developer.chrome.com/blog/autoplay
var SAFARI_AUTOPLAY_ERROR_ABORTED = 'The operation was aborted.';
// This Autoplay error is typically received when Safari's autoplay policy triggers and is set to 'Stop Media with Sound'
var SAFARI_AUTOPLAY_ERROR_PERMISSION_DENIED = // The Autoplay error is typically received when Safari's autoplay policy triggers and is set to 'Never'
'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.';
var SAFARI_AUTOPLAY_POLICY_ERROR_MESSAGES = [
    SAFARI_AUTOPLAY_ERROR_ABORTED,
    SAFARI_AUTOPLAY_ERROR_PERMISSION_DENIED
];
var MS_EDGE_PAUSE_BREAK_WORKAROUND_INTERVAL = 10000;
// Needs to be a value less than the 15s it takes MS Edge to suspend the player when paused
// Date.now() value
var DEFAULT_MAX_INTERNAL_RETRY_ATTEMPTS = 1;
// Max number of retry attempts within the cooldown period
var DEFAULT_INTERNAL_RETRY_COOLDOWN_TIME_MINUTES = 5;
// After X minutes, reset the internal retry count to 0
var FRAMERATE_CAPTURE_INTERVAL_SECONDS = 5;
var FRAMERATE_CAPTURE_INTERVAL_SECONDS_SAFARI = 2;
export var ShakaPlayerEngineItem = /*#__PURE__*/ function(BasePlayerEngineItem) {
    "use strict";
    _inherits(ShakaPlayerEngineItem, BasePlayerEngineItem);
    function ShakaPlayerEngineItem(playerConfig, playerEngineOptions, playoutData, advertBoltOns, playerExtensions, drmBoltOns, precursor, debugConfig, drmConfig) {
        _class_call_check(this, ShakaPlayerEngineItem);
        var _this;
        var _this1;
        var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka, _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig, _CoreVideoInternal_getPropositionExtensions;
        _this = _call_super(this, ShakaPlayerEngineItem, [
            playoutData,
            advertBoltOns,
            playerExtensions,
            playerEngineOptions,
            sdkLogger.withContext('Shaka PEI'),
            {
                hasOwnPositionManagement: false
            },
            debugConfig
        ]), _this1 = _this, _define_property(_this, "playerConfig", void 0), _define_property(_this, "drmBoltOns", void 0), _define_property(_this, "precursor", void 0), _define_property(_this, "drmConfig", void 0), _define_property(_this, "videoElement", void 0), _define_property(_this, "internalRetryStatus", void 0), _define_property(_this, "player", void 0), _define_property(_this, "seeker", void 0), _define_property(_this, "textDisplayer", void 0), _define_property(_this, "audioTracksManager", void 0), _define_property(_this, "textTracksManager", void 0), _define_property(_this, "stateMachineManager", void 0), _define_property(_this, "lastPositionUpdateTime", void 0), _define_property(_this, "isSafari", void 0), _define_property(_this, "isSafariSrcEquals", void 0), _define_property(_this, "isMobileSafari", void 0), _define_property(_this, "isBrowser", void 0), _define_property(_this, "endOfLatestBuffering", void 0), _define_property(_this, "triggerEndOfLatestBuffering", void 0), _define_property(_this, "isInBufferingEvent", void 0), _define_property(_this, "safariMetadataManager", void 0), _define_property(_this, "applyingTizenBufferingWorkaround", void 0), _define_property(_this, "didLoadError", void 0), _define_property(_this, "isExpectingRedundantEarlyPausedStates", void 0), _define_property(_this, "pausedAdBreakWorkaroundInterval", void 0), _define_property(_this, "uInt8ToUtf8Decoder", void 0), _define_property(_this, "audioTracksSwitchSafeMarginSeconds", void 0), _define_property(_this, "variantTracks", void 0), _define_property(_this, "lastActiveVariant_", void 0), _define_property(_this, "timeUpdateIntervalMs", void 0), _define_property(_this, "isInterpolatedPositionEnabled", void 0), _define_property(_this, "omitRegionCodeFromAudioTrack", void 0), _define_property(_this, "postAdBreakCorrectiveSeekTimer", void 0), /** Workaround for browsers that have issues when audio tracks are set while in the Loading state (i.e. Firefox, Safari, etc.) */ _define_property(_this, "deferredSetAudioCall", void 0), _define_property(_this, "elementVisible", void 0), _define_property(_this, "lastHeaders", void 0), _define_property(_this, "debugData", void 0), _define_property(_this, "handleManifestParsed", void 0), _define_property(_this, "handleManifestUpdated", void 0), _define_property(_this, "handleRetryError", void 0), _define_property(_this, "canPlayThrough", void 0), _define_property(_this, "videoElementCreated", void 0), _define_property(_this, "variantChangeRequestedHandler", void 0), _define_property(_this, "variantChangeActuatedHandler", void 0), _define_property(_this, "tracksChangedHandler", void 0), _define_property(_this, "handleTextTrackChanged", void 0), _define_property(_this, "getEncodedFramerate", void 0), _define_property(_this, "handleAutoplayError", void 0), _define_property(_this, "handleFullscreenChanged", void 0), _define_property(_this, "handleClicked", void 0), _define_property(_this, "handlePossibleNewActiveVariant", void 0), _define_property(_this, "onMediaQualityChangedHandler", void 0), _define_property(_this, "adaptationHandler", void 0), _define_property(_this, "timelineRegionToTimedMetadata", void 0), _define_property(_this, "timelineRegionAddedHandler", void 0), _define_property(_this, "largeGapDetectedHandler", void 0), _define_property(_this, "stopForInternalRetry", void 0), _define_property(_this, "getPlayoutDataForInternalRetry", void 0), /**
     *
     * @param event
     * @returns true if retry attempted, false otherwise
     */ _define_property(_this, "handleInternalRetry", void 0), _define_property(_this, "errorHandler", void 0), _define_property(_this, "prftHandler", void 0), _define_property(_this, "handleSegmentDownloaded", void 0), _define_property(_this, "handlePlay", void 0), _define_property(_this, "durationChangeHandler", void 0), _define_property(_this, "handleBuffering", void 0), _define_property(_this, "onCodecSwitchEnded", void 0), _define_property(_this, "handleSeekStarted", void 0), _define_property(_this, "handlePause", void 0), _define_property(_this, "handlePlaying", void 0), _define_property(_this, "isDeviceProsperoShakaLegacy", void 0), _define_property(_this, "handleSeeked", void 0), _define_property(_this, "restoreStateFromVideoElement", void 0), _define_property(_this, "getPositionAdapter", void 0), _define_property(_this, "handleTimeUpdate", void 0), _define_property(_this, "handleTimeUpdateOrig", void 0), /**
     * Fires after Shaka load completes, manually adds all external tracks we have to Shaka
     */ _define_property(_this, "handleLoaded", void 0), _define_property(_this, "emsgHandler", void 0), _define_property(_this, "handleAdBreakFinished", void 0), _this.playerConfig = playerConfig, _this.drmBoltOns = drmBoltOns, _this.precursor = precursor, _this.drmConfig = drmConfig, _this.videoElement = null, _this.lastPositionUpdateTime = 0, _this.isSafari = false, _this.isMobileSafari = false, _this.isBrowser = false, _this.endOfLatestBuffering = Promise.resolve(), _this.isInBufferingEvent = false, _this.applyingTizenBufferingWorkaround = false, _this.didLoadError = false, _this.isExpectingRedundantEarlyPausedStates = false, _this.uInt8ToUtf8Decoder = new TextDecoder('utf-8'), _this.audioTracksSwitchSafeMarginSeconds = 0, _this.variantTracks = [], _this.omitRegionCodeFromAudioTrack = false, _this.postAdBreakCorrectiveSeekTimer = null, _this.elementVisible = true, _this.debugData = {}, _this.handleManifestParsed = function() /* event: shaka.shaka.PlayerEvents.ManifestParsedEvent */ {
            _this.updateShakaPreferredTextTracks();
            _this.notifyManifestParsed();
            _this.updateTrackPreferences();
        }, _this.handleManifestUpdated = function() {
            _this.notifyManifestUpdated();
        }, _this.handleRetryError = function(retryEvent) {
            var shakaError = ShakaPlayerError.fromError(retryEvent.error);
            _this.injectHeaderParameters(shakaError);
            _this.notifyWarning(shakaError);
        }, _this.canPlayThrough = function() {
            var _this_playoutData_preferredSubtitleMetadata, _this_playoutData_preferredSubtitlesLanguages, _this_videoElement, _this_stateMachineManager;
            var activeTextTrack = _this.getActiveTextTrack();
            // In Safari there is an active text track by default on load,
            // so we manually prevent the track from being rendered and set the track
            // mode to hidden so it is clear it should not be shown
            if (_this.isSafariSrcEquals && activeTextTrack && !((_this_playoutData_preferredSubtitleMetadata = _this.playoutData.preferredSubtitleMetadata) === null || _this_playoutData_preferredSubtitleMetadata === void 0 ? void 0 : _this_playoutData_preferredSubtitleMetadata.length) && !((_this_playoutData_preferredSubtitlesLanguages = _this.playoutData.preferredSubtitlesLanguages) === null || _this_playoutData_preferredSubtitlesLanguages === void 0 ? void 0 : _this_playoutData_preferredSubtitlesLanguages.length)) {
                var _this_textTracksManager;
                (_this_textTracksManager = _this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.hideNonForcedSubtitleTracks();
            } else {
                // if we're in multiview and had a VPF retry, we can't rely on preferredAudioLanguages and preferredSubtitlesLanguages because all the multiview
                // streams are the same language. Instead, we need to use the preferredAudioTrack and preferredSubtitlesTrack properties on the playoutData,
                // if available.
                if (_this.playerEngineOptions.isMultiview) {
                    if (_this.playoutData.preferredSubtitlesTrack) {
                        _this.setTextTrack(_this.playoutData.preferredSubtitlesTrack);
                        // setting this immediately without a timeout may still end up being too early for some Safari users.
                        setTimeout(function() {
                            return _this.setTextTrack(_this.playoutData.preferredSubtitlesTrack);
                        }, 100);
                    }
                    // Additionally, we need to call these here for Safari because Shaka tries to set the preferred track based on the config
                    if (_this.isSafariSrcEquals && _this.playoutData.preferredAudioTrack && _this.audioTracksManager) {
                        _this.audioTracksManager.setAudioTrack(_this.playoutData.preferredAudioTrack.id.toString());
                    }
                }
                // This will ensure that users receive the text track changed event if a text track is enabled during loading
                // via preferredSubtitlesLanguages
                _this.handleTextTrackChanged();
            }
            // This is intended to cover the case where the user refreshes the page, which causes the player to be paused after loading (but does not trigger a paused event).
            // This has been targeted at browsers specifically (despite accurately reflecting the state of the video), only the browser is expected to encounter this use case
            // and Samsung was seen to briefly enter a paused state, during normal playback.
            var shouldBeInPausedState = _this.isBrowser && !!((_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.paused);
            (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setCanPlayThrough(shouldBeInPausedState);
            // Live pause videos in Safari get the initial currentTime close to 0
            // this makes the stream start from the start and not from the live edge
            if (_this.isSafariSrcEquals && _this.player.isLive() && Math.floor(_this.videoElement.currentTime) === 0) {
                _this.videoElement.currentTime = _this.player.seekRange().end;
            }
        }, _this.videoElementCreated = function(videoElement) {
            _this.videoElement = videoElement;
            var videoContainer = _this.getVideoContainer();
            if (!videoContainer || _this.didLoadError) {
                var _this_errorObservable;
                (_this_errorObservable = _this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.notifyObservers(ShakaPlayerError.playerLoadError({
                    customMessage: "Video container not available"
                }));
                return;
            }
            _this.initAndAppendVideoElement(videoContainer, _this.playoutData);
            var _this_modifiedBeforeLoad_isMuted;
            if ((_this_modifiedBeforeLoad_isMuted = _this.modifiedBeforeLoad.isMuted) !== null && _this_modifiedBeforeLoad_isMuted !== void 0 ? _this_modifiedBeforeLoad_isMuted : Boolean(_this.playoutData.muted)) {
                _this.nativeMute();
            } else {
                _this.nativeUnmute();
            }
            _this.setVisibilityInternal();
            _this.initSeeker(_this.playoutData);
            if (_this.isSafariSrcEquals) {
                _this.safariMetadataManager = new SafariMetadataManager(_this.videoElement, function(metadata) {
                    _this.notifyTimedMetadataReceived(metadata);
                }, function(metadatas) {
                    _this.notifyBulkTimedMetadataReceived(metadatas);
                });
            }
            _this.tizenPrerollWorkaround();
            _this.handleRenderedFramerateChanged(function() {
                return _this.getTotalRenderedFramesFromVideoElement(_this.videoElement);
            }, _this.isSafariSrcEquals ? FRAMERATE_CAPTURE_INTERVAL_SECONDS_SAFARI : FRAMERATE_CAPTURE_INTERVAL_SECONDS);
            _this.addShakaEventHandlers();
            _this.notifyVideoElementCreated(videoElement);
        }, _this.variantChangeRequestedHandler = function() {
            var _this_audioTracksManager, _this_audioTracksManager1;
            _this.variantTracks = _this.player.getVariantTracks();
            (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.setVariantTracks(_this.variantTracks);
            _this.handlePossibleNewActiveVariant();
            var activeAudioTrackId = (_this_audioTracksManager1 = _this.audioTracksManager) === null || _this_audioTracksManager1 === void 0 ? void 0 : _this_audioTracksManager1.getActiveAudioTrackId();
            if (typeof activeAudioTrackId !== 'undefined') {
                _this.notifyAudioTrackChanged(activeAudioTrackId);
            }
        }, _this.variantChangeActuatedHandler = function() {
            _this.handleAudioTracksChanged(true);
        }, _this.tracksChangedHandler = function() {
            var _this_audioTracksManager;
            _this.updateShakaPreferredTextTracks();
            _this.variantTracks = _this.getVariantTracks({
                refresh: true
            });
            (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.setVariantTracks(_this.variantTracks);
            _this.handleSubtitleTracksChanges();
            _this.handleAudioTracksChanged();
        }, _this.handleTextTrackChanged = function() /* event: shaka.shaka.PlayerEvents.TextChangedEvent */ {
            var _this_textTracksManager;
            (_this_textTracksManager = _this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.handleTextTrackChanged();
        }, _this.getEncodedFramerate = function() {
            var variantTracks = _this.getVariantTracks();
            var activeTrack = variantTracks.find(function(variantTrack) {
                return variantTrack.active;
            });
            return activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.frameRate;
        }, _this.handleAutoplayError = function(msg) {
            if (_this.isSafari) {
                if (msg.includes(SAFARI_AUTOPLAY_ERROR_ABORTED)) {
                    _this.isExpectingRedundantEarlyPausedStates = true;
                }
                if (SAFARI_AUTOPLAY_POLICY_ERROR_MESSAGES.filter(function(safariMsg) {
                    return msg.includes(safariMsg);
                }).length > 0) {
                    _this.notifyAutoPlayPolicyPreventedPlayback();
                }
            } else if (_this.isBrowser && msg.includes(AUTOPLAY_NOT_ALLOWED_ERROR_NAME)) {
                _this.notifyAutoPlayPolicyPreventedPlayback();
            }
        }, _this.handleFullscreenChanged = function(isFullscreen) {
            _this.notifyFullscreenChanged(isFullscreen);
        }, _this.handleClicked = function() {
            _this.notifyClicked();
        }, _this.handlePossibleNewActiveVariant = function(activeTrack) {
            var _this_variantTracks, _activeTrack_audioId, _this_audioTracksManager, _this_lastActiveVariant_, _this_lastActiveVariant_1;
            activeTrack = activeTrack !== null && activeTrack !== void 0 ? activeTrack : (_this_variantTracks = _this.variantTracks) === null || _this_variantTracks === void 0 ? void 0 : _this_variantTracks.find(function(t) {
                return t.active;
            });
            if (!activeTrack) {
                return;
            }
            if (activeTrack === _this.lastActiveVariant_) {
                return;
            }
            // Does the current active codec differ from what was emitted previously?
            var closestClientFacingTrack = (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.getClosestReducedMatch((_activeTrack_audioId = activeTrack.audioId) === null || _activeTrack_audioId === void 0 ? void 0 : _activeTrack_audioId.toString());
            var hasCodecChanged = ((_this_lastActiveVariant_ = _this.lastActiveVariant_) === null || _this_lastActiveVariant_ === void 0 ? void 0 : _this_lastActiveVariant_.audioCodec) !== activeTrack.audioCodec || closestClientFacingTrack && (closestClientFacingTrack === null || closestClientFacingTrack === void 0 ? void 0 : closestClientFacingTrack.audioCodec) !== activeTrack.audioCodec;
            var hasQuadrantChanged = _this.playerEngineOptions.isMultiview && ((_this_lastActiveVariant_1 = _this.lastActiveVariant_) === null || _this_lastActiveVariant_1 === void 0 ? void 0 : _this_lastActiveVariant_1.label) !== activeTrack.label;
            if (_this.lastActiveVariant_ && (hasCodecChanged || hasQuadrantChanged)) {
                _this.handleAudioTracksChanged();
            }
            _this.lastActiveVariant_ = activeTrack;
        }, _this.onMediaQualityChangedHandler = function(event) {
            if (!isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_MEDIA_QUALITY_CHANGED_EVENT)) return;
            if (event.mediaQuality.contentType !== 'video') {
                return;
            }
            var bandwidthBitsSec = event.mediaQuality.bandwidth;
            var frameRate = event.mediaQuality.frameRate;
            _this.notifyVideoTrackChanged({
                bitrateKbps: bandwidthBitsSec / 1000,
                resolution: {
                    width: event.mediaQuality.width,
                    height: event.mediaQuality.height
                },
                videoCodec: event.mediaQuality.codecs,
                frameRate: frameRate
            });
            _this.notifyBitrateChanged({
                bitrateKbps: bandwidthBitsSec / 1000,
                resolution: {
                    width: event.mediaQuality.width,
                    height: event.mediaQuality.height
                }
            });
            if (frameRate) {
                _this.notifyEncodedFrameRateChanged(frameRate);
            }
        }, _this.adaptationHandler = function() {
            var _this_audioTracksManager;
            var variantTracks = _this.player.getVariantTracks();
            _this.variantTracks = variantTracks;
            (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.setVariantTracks(_this.variantTracks);
            var activeTrack = variantTracks.find(function(variantTrack) {
                return variantTrack.active;
            });
            if (!activeTrack) {
                return;
            }
            _this.handlePossibleNewActiveVariant(activeTrack);
            // Below should be removed in favour of onMediaQualityChangedHandler above when we scrap shaka 3.0.5
            if (isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_MEDIA_QUALITY_CHANGED_EVENT)) return;
            var bandwidthBitsSec = activeTrack.videoBandwidth;
            var frameRate = activeTrack.frameRate;
            _this.notifyVideoTrackChanged({
                bitrateKbps: bandwidthBitsSec / 1000,
                resolution: {
                    width: activeTrack.width,
                    height: activeTrack.height
                },
                videoCodec: activeTrack.videoCodec,
                frameRate: frameRate
            });
            _this.notifyBitrateChanged({
                // NOTE: Since Sky only uses audio streams with one bitrate this will only trigger once
                // and we are thereby only considering that this will be triggered when there is an abr change
                // in video bitrate
                bitrateKbps: bandwidthBitsSec / 1000,
                resolution: {
                    width: activeTrack.width,
                    height: activeTrack.height
                }
            });
            if (frameRate) {
                _this.notifyEncodedFrameRateChanged(frameRate);
            }
        }, _this.timelineRegionToTimedMetadata = function(region) {
            if (region.schemeIdUri === 'hls:daterange') {
                var attrs = JSON.parse(region.value);
                var scte35Cmd = attrs.scte35Cmd, scte35In = attrs.scte35In, scte35Out = attrs.scte35Out, rest = _object_without_properties(attrs, [
                    "scte35Cmd",
                    "scte35In",
                    "scte35Out"
                ]);
                var _ref;
                return {
                    type: TimedMetadataType.HlsDaterange,
                    clientAttributes: _object_spread_props(_object_spread({}, rest), {
                        scte35Data: (_ref = scte35Cmd !== null && scte35Cmd !== void 0 ? scte35Cmd : scte35In) !== null && _ref !== void 0 ? _ref : scte35Out
                    }),
                    id: region.id,
                    playerTime: region.startTime,
                    duration: region.endTime - region.startTime,
                    class: attrs.class
                };
            } else {
                var _region_eventNode, _region_eventNode1;
                return {
                    type: TimedMetadataType.EventStream,
                    playHeadTime: _this.currentPosition,
                    textContent: getTextContents((_region_eventNode = region.eventNode) !== null && _region_eventNode !== void 0 ? _region_eventNode : region.eventElement),
                    scte35Data: getScte35String((_region_eventNode1 = region.eventNode) !== null && _region_eventNode1 !== void 0 ? _region_eventNode1 : region.eventElement),
                    id: region.id,
                    schemeIdUri: region.schemeIdUri,
                    startTime: region.startTime,
                    endTime: region.endTime,
                    value: region.value
                };
            }
        }, _this.timelineRegionAddedHandler = function(event) {
            var region = _this.timelineRegionToTimedMetadata(event.detail);
            _this.notifyTimedMetadataReceived(region);
        }, _this.largeGapDetectedHandler = function(event) {
            var _this_player;
            _this.logger.breadcrumb("Large gap detected by Shaka while playing ".concat((_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getAssetUri(), "\nCurrent Time: ").concat(event.currentTime, "\nGap Size: ").concat(event.gapSize));
        }, _this.stopForInternalRetry = function() {
            var _this_pausedAdBreakWorkaroundInterval, _this_seeker, _this_precursor, _this_stateMachineManager, _this_renderedFrameRateInterval;
            (_this_pausedAdBreakWorkaroundInterval = _this.pausedAdBreakWorkaroundInterval) === null || _this_pausedAdBreakWorkaroundInterval === void 0 ? void 0 : _this_pausedAdBreakWorkaroundInterval.stop();
            _this.pausedAdBreakWorkaroundInterval = undefined;
            (_this_seeker = _this.seeker) === null || _this_seeker === void 0 ? void 0 : _this_seeker.destroy();
            _this.seeker = undefined;
            (_this_precursor = _this.precursor) === null || _this_precursor === void 0 ? void 0 : _this_precursor.destroy();
            // To be remove once the version of shaka player is v41000
            _this.removeVideoElement();
            _this.removeShakaEventHandlers();
            (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.destroy(true);
            (_this_renderedFrameRateInterval = _this.renderedFrameRateInterval) === null || _this_renderedFrameRateInterval === void 0 ? void 0 : _this_renderedFrameRateInterval.stop();
        }, _this.getPlayoutDataForInternalRetry = function(liveWindow) {
            var _this_videoElement, _this_videoElement1, _this_audioTracksManager_getLastSelectedAudioTrack, _this_audioTracksManager, _this_textTracksManager, _this_audioTracksManager_getLastSelectedAudioTrack1, _this_audioTracksManager1;
            var volume = (_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.volume;
            var muted = (_this_videoElement1 = _this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.muted;
            var _this_audioTracksManager_getLastSelectedAudioTrack_originalLanguage;
            var lastAudioLanguage = (_this_audioTracksManager_getLastSelectedAudioTrack_originalLanguage = (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : (_this_audioTracksManager_getLastSelectedAudioTrack = _this_audioTracksManager.getLastSelectedAudioTrack()) === null || _this_audioTracksManager_getLastSelectedAudioTrack === void 0 ? void 0 : _this_audioTracksManager_getLastSelectedAudioTrack.originalLanguage) !== null && _this_audioTracksManager_getLastSelectedAudioTrack_originalLanguage !== void 0 ? _this_audioTracksManager_getLastSelectedAudioTrack_originalLanguage : null;
            var lastSubtitledTrack = (_this_textTracksManager = _this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.getLastSelectedTrack();
            var _this_audioTracksManager_getLastSelectedAudioTrack_roles;
            var lastAudioRoles = (_this_audioTracksManager_getLastSelectedAudioTrack_roles = (_this_audioTracksManager1 = _this.audioTracksManager) === null || _this_audioTracksManager1 === void 0 ? void 0 : (_this_audioTracksManager_getLastSelectedAudioTrack1 = _this_audioTracksManager1.getLastSelectedAudioTrack()) === null || _this_audioTracksManager_getLastSelectedAudioTrack1 === void 0 ? void 0 : _this_audioTracksManager_getLastSelectedAudioTrack1.roles) !== null && _this_audioTracksManager_getLastSelectedAudioTrack_roles !== void 0 ? _this_audioTracksManager_getLastSelectedAudioTrack_roles : null;
            var isAudioDescription = lastAudioRoles === null || lastAudioRoles === void 0 ? void 0 : lastAudioRoles.includes(AudioRole.Description);
            var reloadPlayoutData = _object_spread_props(_object_spread({}, _this.playoutData), {
                preferredAudioLanguages: lastAudioLanguage ? [
                    lastAudioLanguage
                ] : [],
                preferredSubtitlesLanguages: (lastSubtitledTrack === null || lastSubtitledTrack === void 0 ? void 0 : lastSubtitledTrack.originalLanguage) ? [
                    lastSubtitledTrack.originalLanguage
                ] : [],
                preferredAudioMetadata: lastAudioLanguage ? [
                    {
                        languageTag: lastAudioLanguage,
                        isAudioDescription: isAudioDescription
                    }
                ] : [],
                preferredSubtitleMetadata: (lastSubtitledTrack === null || lastSubtitledTrack === void 0 ? void 0 : lastSubtitledTrack.originalLanguage) ? [
                    {
                        languageTag: lastSubtitledTrack.originalLanguage
                    }
                ] : [],
                autoplay: true,
                volume: volume,
                muted: muted,
                position: _this.currentPosition,
                linearPosition: {
                    position: _this.currentPosition,
                    liveWindow: liveWindow
                }
            });
            return reloadPlayoutData;
        }, _this.handleInternalRetry = function() {
            var _this_player_getMediaKeysData, _this_player, _this_seeker;
            _this.internalRetryStatus.retryCount += 1;
            _this.internalRetryStatus.lastAttemptedRetry = Date.now();
            var drmData = !!_this.playoutData.drmConfiguration && ((_this_player = _this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getMediaKeysData = _this_player.getMediaKeysData) === null || _this_player_getMediaKeysData === void 0 ? void 0 : _this_player_getMediaKeysData.call(_this_player));
            if (drmData) {
                var mediaKeysInstance = drmData.mediaKeysInstance, activeSessions = drmData.activeSessions;
                _this.internalRetryStatus.mediaKeys = mediaKeysInstance;
                _this.internalRetryStatus.activeSessions = activeSessions;
            }
            var liveWindow = (_this_seeker = _this.seeker) === null || _this_seeker === void 0 ? void 0 : _this_seeker.getLiveWindow();
            _this.stopForInternalRetry();
            var reloadPlayoutData = _this.getPlayoutDataForInternalRetry(liveWindow);
            _this.precursor = new ShakaPlayerEngineItemPrecursor(CoreVideoInternal.playerCapabilities, reloadPlayoutData, _this.playerConfig, _this.advertBoltOns, _this.drmBoltOns, false, // preload dummy value for now, as internal retry is not used
            _this.drmConfig, _this.playerEngineOptions);
            _this.internalRetryStatus.firstPositionReceivedAfterRetry = false;
            _this.nativeLoad(reloadPlayoutData);
        }, _this.errorHandler = function(event) {
            if (_this.internalRetryStatus.enabled && _this.shouldInternalRetryFromError(event)) {
                _this.handleInternalRetry();
                return;
            }
            _this.logger.breadcrumb("Error in Shaka PEI - Event ".concat(JsonUtils.stringify(event)));
            var adaptedError = ShakaPlayerError.fromError(event.detail, CoreVideoInternal.deviceInfo.deviceChipset);
            _this.injectHeaderParameters(adaptedError);
            _this.notifyError(adaptedError);
        }, _this.prftHandler = function(event) {
            var _this_seeker;
            (_this_seeker = _this.seeker) === null || _this_seeker === void 0 ? void 0 : _this_seeker.setPresentationStartDate(event.detail.programStartDate);
        }, _this.handleSegmentDownloaded = function(event) {
            var _this_bandwidthEstimator;
            var response = event.detail.response;
            (_this_bandwidthEstimator = _this.bandwidthEstimator) === null || _this_bandwidthEstimator === void 0 ? void 0 : _this_bandwidthEstimator.sample((response === null || response === void 0 ? void 0 : response.timeMs) || 0, Date.now(), (response === null || response === void 0 ? void 0 : response.data.byteLength) || 0);
        }, _this.handlePlay = function() {
            _this.notifyPlayStart();
        }, _this.durationChangeHandler = function() {
            _this.notifyDurationChanged(_this.videoElement.duration);
        }, _this.handleBuffering = function(event) {
            if (event.buffering && !_this.isInBufferingEvent) {
                _this.isInBufferingEvent = true;
                _this.endOfLatestBuffering = new Promise(function(res) {
                    _this.triggerEndOfLatestBuffering = function() {
                        res();
                        _this.isInBufferingEvent = false;
                        _this.playerBufferingAndLoadingWorkaround();
                    };
                });
            } else if (!event.buffering && _this.triggerEndOfLatestBuffering) {
                _this.triggerEndOfLatestBuffering();
            }
            if (_this.state === PlayerState.Loading) {
                return;
            }
            if (event.buffering) {
                var _this_stateMachineManager;
                return (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setRebuffering();
            }
            if (_this.state === PlayerState.Rebuffering) {
                var _this_audioTracksManager, _this_videoElement;
                if (((_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.isCodecSwitching) === false || ((_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.readyState) === HTMLMediaElement.HAVE_ENOUGH_DATA) {
                    _this.onCodecSwitchEnded();
                } else {
                    var _this_videoElement1;
                    (_this_videoElement1 = _this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.addEventListener('canplaythrough', _this.onCodecSwitchEnded);
                }
            }
        }, _this.onCodecSwitchEnded = function() {
            var _this_videoElement, _this_audioTracksManager;
            (_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.removeEventListener('canplaythrough', _this.onCodecSwitchEnded);
            (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.resetCodecSwitch();
            _this.restoreStateFromVideoElement();
        }, _this.handleSeekStarted = function() {
            var _this_videoElement;
            // `seekStarted` must be notified before `buffering` so that it is not counted as connection induced
            var shouldNotifySeek = _this.catchNonEngineItemSeek({
                from: _this.currentPosition,
                to: (_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.currentTime
            });
            if (shouldNotifySeek || _this.shouldIgnoreStateAndPositionChanges) {
                var _this_stateMachineManager;
                (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setSeeking();
            }
        }, _this.handlePause = /*#__PURE__*/ _async_to_generator(function() {
            var _this_videoElement, _this_videoElement1, _this_audioTracksManager, _this_stateMachineManager;
            return _ts_generator(this, function(_state) {
                /**
         * Sometimes on Safari (observed on 15.5) the paused state is given too early, which leads to extra states being reported and the appearance of buffering finishing when it actually hasn't.
         * --
         * When an asset finishes, a Paused state is being emitted.
         * Its an unnecessary state since the session will end after so better to ignore this specific scenario.
         */ if (_this1.state === PlayerState.Seeking || _this1.isExpectingRedundantEarlyPausedStates && !((_this_videoElement = _this1.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.buffered.length) || ((_this_videoElement1 = _this1.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.ended)) {
                    return [
                        2
                    ];
                }
                (_this_audioTracksManager = _this1.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.handlePaused();
                (_this_stateMachineManager = _this1.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setPaused();
                return [
                    2
                ];
            });
        }), _this.handlePlaying = /*#__PURE__*/ _async_to_generator(function() {
            var _this_videoElement, _this_audioTracksManager, _this_stateMachineManager;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.endOfLatestBuffering
                        ];
                    case 1:
                        _state.sent();
                        /**
         * When the playing event is emitted it is expected for videoElement.paused to be false. So if it is true we will ignore it.
         */ if ((_this_videoElement = _this1.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.paused) {
                            return [
                                2
                            ];
                        }
                        (_this_audioTracksManager = _this1.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.handlePlaying();
                        (_this_stateMachineManager = _this1.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setPlaying();
                        if (_this1.deferredSetAudioCall && _this1.state === PlayerState.Playing) {
                            // Fire pending setAudio call (must only occur after Playing state is surely set)
                            _this1.logger.warn("Firing deferred setAudioTrack('".concat(_this1.deferredSetAudioCall, "')"));
                            _this1.nativeSetAudioTrack(_this1.deferredSetAudioCall);
                            _this1.deferredSetAudioCall = undefined;
                        }
                        return [
                            2
                        ];
                }
            });
        }), _this.isDeviceProsperoShakaLegacy = function(deviceType, shakaPlayerVersion) {
            if (shakaPlayerVersion === ShakaPlayerVersion.V_3_0_5 && deviceType === DeviceType.Prospero) {
                return true;
            }
            return false;
        }, _this.handleSeeked = /*#__PURE__*/ _async_to_generator(function() {
            var _this_textTracksManager, _this_seeker, _this_stateMachineManager, lastSubtitlesTrack, _this_textTracksManager1, _this_stateMachineManager1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!// It is not safe to rely on Safari to call the Buffering end event
                        !_this1.isSafari) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this1.endOfLatestBuffering
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        // This is a workaround for an issue when using ttml subtitles where seeking too far
                        // ahead would cause the subtitles to stop rendering until a new track is selected
                        lastSubtitlesTrack = (_this_textTracksManager = _this1.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.getLastSelectedTrack();
                        if (lastSubtitlesTrack && (!lastSubtitlesTrack.mimeType || lastSubtitlesTrack.mimeType === TextTrackMimeType.TTML || lastSubtitlesTrack.mimeType === TextTrackMimeType.WebVTT && _this1.isDeviceProsperoShakaLegacy(CoreVideoInternal.deviceType, _this1.playerConfig.shakaPlayerVersion))) {
                            ;
                            (_this_textTracksManager1 = _this1.textTracksManager) === null || _this_textTracksManager1 === void 0 ? void 0 : _this_textTracksManager1.forceReEnableSelectedTrack();
                        }
                        if (_this1.applyingTizenBufferingWorkaround) {
                            ;
                            (_this_stateMachineManager1 = _this1.stateMachineManager) === null || _this_stateMachineManager1 === void 0 ? void 0 : _this_stateMachineManager1.setPlaying();
                            _this1.applyingTizenBufferingWorkaround = false;
                        }
                        return [
                            4,
                            (_this_seeker = _this1.seeker) === null || _this_seeker === void 0 ? void 0 : _this_seeker.handleSeeked()
                        ];
                    case 3:
                        _state.sent();
                        (_this_stateMachineManager = _this1.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setSeekEnded();
                        return [
                            2
                        ];
                }
            });
        }), _this.restoreStateFromVideoElement = function() {
            if (_this.videoElement.paused) {
                var _this_stateMachineManager;
                (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setPaused();
            } else {
                var _this_stateMachineManager1;
                (_this_stateMachineManager1 = _this.stateMachineManager) === null || _this_stateMachineManager1 === void 0 ? void 0 : _this_stateMachineManager1.setPlaying();
            }
        }, _this.getPositionAdapter = function(event) {
            var videoElement = event === null || event === void 0 ? void 0 : event.target;
            var positionSec = videoElement.currentTime;
            return function() {
                return positionSec;
            };
        }, _this.handleTimeUpdate = function(event) {
            if (!_this.isInterpolatedPositionEnabled) {
                _this.handleTimeUpdateOrig(event);
                return;
            }
            if (!event.target) {
                _this.logger.warn('No video element with time update');
                return;
            }
            _this.interpolatePosition(function(positionSec) {
                _this.handleTimeUpdateOrig(event);
            }, _this.getPositionAdapter(event), undefined)(undefined, false);
        }, _this.handleTimeUpdateOrig = function(event) {
            var _this_textTracksManager, _this_textDisplayer;
            if (_this.shouldIgnoreStateAndPositionChanges) {
                return;
            }
            var currentTime = Date.now();
            if (!event.target) {
                _this.logger.warn('No video element with time update');
                return;
            }
            var videoElement = event.target;
            var positionSec = videoElement.currentTime;
            if (currentTime - _this.lastPositionUpdateTime < _this.timeUpdateIntervalMs) {
                return;
            }
            // After an internal retry, there can be a rogue 0 position when loading begins
            // this can cause an issue with the seeking manager on linear content, so ignore it
            if (_this.internalRetryStatus.enabled && !_this.internalRetryStatus.firstPositionReceivedAfterRetry && positionSec === 0) {
                _this.logger.info('Ignoring initial 0 position after internal retry');
                _this.internalRetryStatus.firstPositionReceivedAfterRetry = true;
                return;
            }
            _this.lastPositionUpdateTime = currentTime;
            (_this_textTracksManager = _this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.updateCurrentPosition(positionSec);
            (_this_textDisplayer = _this.textDisplayer) === null || _this_textDisplayer === void 0 ? void 0 : _this_textDisplayer.handlePositionChanged(positionSec);
            _this.notifyPositionChanged(positionSec);
        }, _this.handleLoaded = function() {
            var // shaka v41000 and newer with the preload manager, won't have image tracks
            // available until here
            _this_thumbnailManager, _this_videoElement;
            (_this_thumbnailManager = _this.thumbnailManager) === null || _this_thumbnailManager === void 0 ? void 0 : _this_thumbnailManager.handleLoaded();
            if (_this.playoutData.externalTracks) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this.playoutData.externalTracks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var track = _step.value;
                        var _track_roles, _this_player;
                        (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.addTextTrack(track.uri, track.language, (_track_roles = track.roles) === null || _track_roles === void 0 ? void 0 : _track_roles.toString(), track.mimeType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (_this.isMobileSafari && ((_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.paused)) {
                var // we need to let the player know we're paused
                // -- fixes an issue in mobile Safari where the canPlayThrough event won't fire until play starts
                _this_stateMachineManager;
                (_this_stateMachineManager = _this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setCanPlayThrough(true);
            }
        }, _this.emsgHandler = function(event) {
            var emsgInfo = event.detail;
            var decodedMessageData = _this.uInt8ToUtf8Decoder.decode(new Uint8Array(emsgInfo.messageData));
            var emsgEvent = {
                id: emsgInfo.id,
                value: emsgInfo.value,
                type: TimedMetadataType.EMsg,
                presentationTime: emsgInfo.startTime,
                schemeIdUri: emsgInfo.schemeIdUri,
                messageData: decodedMessageData
            };
            _this.scheduleEmsgEvent(emsgEvent);
        }, _this.handleAdBreakFinished = function(adBreak) {
            var _this_playerConfig_postAdBreakCorrectiveSeek;
            if ((_this_playerConfig_postAdBreakCorrectiveSeek = _this.playerConfig.postAdBreakCorrectiveSeek) === null || _this_playerConfig_postAdBreakCorrectiveSeek === void 0 ? void 0 : _this_playerConfig_postAdBreakCorrectiveSeek.enable) {
                _this.installPostAdBreakSeek(adBreak, _this.playerConfig.postAdBreakCorrectiveSeek);
            }
        };
        _this.logger.info("Shaka player config -> ".concat(JsonUtils.stringify(_this.playerConfig)));
        var deviceInfo = CoreVideoInternal.deviceInfo, deviceType = CoreVideoInternal.deviceType;
        _this.internalRetryStatus = {
            enabled: ShakaPlayerEngineItemPrecursor.checkIsInternalRetryEnabled(_this.playoutData),
            lastAttemptedRetry: 0,
            retryCount: 0,
            firstPositionReceivedAfterRetry: false,
            mediaKeys: undefined,
            // Shaka doesn't like `null` values in config
            activeSessions: undefined,
            // Shaka doesn't like `null` values in config
            startTime: Date.now()
        };
        _this.isSafari = isSafariDesktop(deviceInfo, deviceType);
        // Indicates if we're using Safari in src= mode or in MSE mode. MSE can be enabled experimentally since shaka 4.2.12
        _this.isSafariSrcEquals = _this.isSafari && !(_this.playerConfig.useMseOnSafari && isVersionCompliant(shaka.Player.version, 'v4.2.12'));
        _this.isBrowser = deviceType === DeviceType.Browser;
        _this.isMobileSafari = isSafariMobile(deviceInfo, deviceType);
        _this.textDisplayer = new ShakaPlayerEngineSubtitles(_this.notifySubtitleCuesChanged.bind(_this), _this.clearSubtitles.bind(_this));
        _this.audioTracksSwitchSafeMarginSeconds = _this.getAudioTrackChangeSafeMargin();
        var timeUpdateConfigValue = getTimeUpdateConfig(_this.playoutData);
        var _timeUpdateConfigValue_timeIntervalMs;
        _this.timeUpdateIntervalMs = (_timeUpdateConfigValue_timeIntervalMs = timeUpdateConfigValue === null || timeUpdateConfigValue === void 0 ? void 0 : timeUpdateConfigValue.timeIntervalMs) !== null && _timeUpdateConfigValue_timeIntervalMs !== void 0 ? _timeUpdateConfigValue_timeIntervalMs : TIME_UPDATE_DEFAULT_INTERVAL_MS;
        var _timeUpdateConfigValue_isInterpolatedPositionEnabled;
        _this.isInterpolatedPositionEnabled = (_timeUpdateConfigValue_isInterpolatedPositionEnabled = timeUpdateConfigValue === null || timeUpdateConfigValue === void 0 ? void 0 : timeUpdateConfigValue.isInterpolatedPositionEnabled) !== null && _timeUpdateConfigValue_isInterpolatedPositionEnabled !== void 0 ? _timeUpdateConfigValue_isInterpolatedPositionEnabled : false;
        _this.logger.info("isInterpolatedPositionEnabled -> ".concat(timeUpdateConfigValue === null || timeUpdateConfigValue === void 0 ? void 0 : timeUpdateConfigValue.isInterpolatedPositionEnabled));
        _this.logger.info("using timeupdate interval -> ".concat(_this.timeUpdateIntervalMs, " ").concat((timeUpdateConfigValue === null || timeUpdateConfigValue === void 0 ? void 0 : timeUpdateConfigValue.isInterpolatedPositionEnabled) ? " - this interval will be overridden by Interpolation strategy" : ""));
        var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka_omitRegionCodeFromAudioTrack;
        _this.omitRegionCodeFromAudioTrack = (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka_omitRegionCodeFromAudioTrack = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig = _CoreVideoInternal_getPropositionExtensions.propositionPlayerConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka = _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig[PlayerType.Shaka]) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka.omitRegionCodeFromAudioTrack) !== null && _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka_omitRegionCodeFromAudioTrack !== void 0 ? _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka_omitRegionCodeFromAudioTrack : false;
        return _this;
    }
    _create_class(ShakaPlayerEngineItem, [
        {
            key: "updateMultiviewTrackPreferences",
            value: // Uncomment the line below to see logs from Shaka when you use debug mode
            // (shaka as any).log.setLevel((shaka as any).log.Level.DEBUG);
            function updateMultiviewTrackPreferences(preferredTrack) {
                var _this_playoutData_preferredAudioMetadata;
                if (!this.player) {
                    return;
                }
                var preferredAudioTrack = this.playoutData.preferredAudioTrack;
                var preferredLanguage;
                var preferredLabel = '';
                var preferredVariantRole;
                // If we have any preferred track, copy it's label to config. This way shaka will select it as soon as possible.
                if (preferredAudioTrack === null || preferredAudioTrack === void 0 ? void 0 : preferredAudioTrack.label) {
                    var _preferredAudioTrack_roles;
                    preferredLanguage = preferredAudioTrack.language;
                    preferredLabel = preferredAudioTrack.label;
                    preferredVariantRole = ((_preferredAudioTrack_roles = preferredAudioTrack.roles) === null || _preferredAudioTrack_roles === void 0 ? void 0 : _preferredAudioTrack_roles.includes(AudioRole.Description)) ? AudioRole.Description : undefined;
                } else if ((_this_playoutData_preferredAudioMetadata = this.playoutData.preferredAudioMetadata) === null || _this_playoutData_preferredAudioMetadata === void 0 ? void 0 : _this_playoutData_preferredAudioMetadata.length) {
                    var availableAudioLanguages = this.player.getAudioLanguagesAndRoles();
                    if (preferredTrack) {
                        var _preferredTrack_roles;
                        preferredLanguage = preferredTrack.language;
                        preferredVariantRole = (_preferredTrack_roles = preferredTrack.roles) === null || _preferredTrack_roles === void 0 ? void 0 : _preferredTrack_roles[0];
                    } else {
                        preferredLanguage = availableAudioLanguages[0].language;
                    }
                } else {
                    var preferredAudioLanguages = this.playoutData.preferredAudioLanguages;
                    var availableAudioLanguages1 = this.player.getAudioLanguages();
                    var compatibleAudioLanguages = availableAudioLanguages1.filter(function(track) {
                        return preferredAudioLanguages === null || preferredAudioLanguages === void 0 ? void 0 : preferredAudioLanguages.includes(track);
                    });
                    if (compatibleAudioLanguages.length) {
                        preferredLanguage = compatibleAudioLanguages[0];
                    } else {
                        preferredLanguage = availableAudioLanguages1[0];
                    }
                }
                // We're looking here for a track which label starts with PIP-1 as it corresponds with first multiview picture.
                if (!preferredLabel) {
                    var track = this.player.getVariantTracks().find(function(track) {
                        var _track_label;
                        return shaka.util.LanguageUtils.areLanguageCompatible(track.language, preferredLanguage) && ((_track_label = track.label) === null || _track_label === void 0 ? void 0 : _track_label.startsWith('PIP-1_'));
                    });
                    if (track === null || track === void 0 ? void 0 : track.label) {
                        preferredLabel = track.label;
                    }
                }
                if (preferredLabel) {
                    var updatedConfig = {
                        streaming: {
                            prefetchAudioLanguages: [
                                preferredLanguage
                            ]
                        },
                        preferredAudioLabel: preferredLabel,
                        preferredVariantRole: preferredVariantRole
                    };
                    this.logger.info("Updating player config with: ".concat(JSON.stringify(updatedConfig)));
                    this.player.configure(updatedConfig);
                }
            }
        },
        {
            key: "updateTrackPreferences",
            value: function updateTrackPreferences() {
                var _this_playoutData_preferredAudioMetadata;
                if (!this.player) {
                    return;
                }
                var availableAudioTracks, preferredTrack;
                if ((_this_playoutData_preferredAudioMetadata = this.playoutData.preferredAudioMetadata) === null || _this_playoutData_preferredAudioMetadata === void 0 ? void 0 : _this_playoutData_preferredAudioMetadata.length) {
                    var _this_audioTracksManager;
                    availableAudioTracks = (_this_audioTracksManager = this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.buildReducedAudioTrackList();
                    preferredTrack = getPreferredTrackFromMetadata(this.playoutData.preferredAudioMetadata, availableAudioTracks);
                }
                if (!this.playerEngineOptions.isMultiview) {
                    if (preferredTrack) {
                        var _preferredTrack_roles, _this_player;
                        (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.configure({
                            preferredAudioLanguage: preferredTrack === null || preferredTrack === void 0 ? void 0 : preferredTrack.language,
                            preferredVariantRole: (preferredTrack === null || preferredTrack === void 0 ? void 0 : (_preferredTrack_roles = preferredTrack.roles) === null || _preferredTrack_roles === void 0 ? void 0 : _preferredTrack_roles.includes(AudioRole.Description)) ? AudioRole.Description.toLowerCase() : ''
                        });
                    }
                } else {
                    this.updateMultiviewTrackPreferences(preferredTrack);
                }
            }
        },
        {
            key: "setPlayoutRect",
            value: function setPlayoutRect(playoutRect) {
                this.logger.info("Setting playout rect ".concat(playoutRect));
            }
        },
        {
            key: "setVisibility",
            value: function setVisibility(visible) {
                this.elementVisible = visible;
                this.setVisibilityInternal();
            }
        },
        {
            key: "setVisibilityInternal",
            value: function setVisibilityInternal() {
                var _this_videoElement;
                var videoStyle = (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.style;
                if (!videoStyle) {
                    return;
                }
                if (this.elementVisible) {
                    this.setDefaultVideoStyle();
                } else {
                    videoStyle.setProperty('display', 'none');
                }
            }
        },
        {
            key: "getBufferedInfo",
            value: function getBufferedInfo() {
                var _this_player;
                var info = (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getBufferedInfo();
                if (!info) {
                    return null;
                }
                return {
                    total: info.total,
                    video: info.video,
                    audio: info.audio
                };
            }
        },
        {
            key: "getNativeTelemetryData",
            value: function getNativeTelemetryData() {
                var _this_player;
                var stats = (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getStats();
                if (!stats) {
                    return {};
                }
                return {
                    encodedFramerates: this.getEncodedFramerate(),
                    decodedFrames: stats.decodedFrames,
                    droppedFrames: stats.droppedFrames,
                    corruptedFrames: stats.corruptedFrames,
                    estimatedBandwidth: stats.estimatedBandwidth,
                    nonFatalErrorCount: stats.nonFatalErrorCount,
                    manifestTimeSeconds: stats.manifestTimeSeconds,
                    manifestDownloadTimeSeconds: stats.manifestDownloadTimeSeconds,
                    manifestParseTimeSeconds: stats.manifestParseTimeSeconds,
                    manifestSizeBytes: stats.manifestSizeBytes,
                    manifestPeriodCount: stats.manifestPeriodCount,
                    manifestGapCount: stats.manifestGapCount,
                    maxSegmentDuration: stats.maxSegmentDuration,
                    drmTimeSeconds: stats.drmTimeSeconds,
                    licenseTime: stats.licenseTime,
                    loadLatency: stats.loadLatency,
                    currentPositionSeconds: this.currentPosition,
                    bufferedInfo: this.getBufferedInfo() || undefined
                };
            }
        },
        {
            key: "nativeLiveWindow",
            value: function nativeLiveWindow() {
                if (this.seeker) {
                    return Promise.resolve(this.seeker.getLiveWindow());
                }
                return Promise.resolve(null);
            }
        },
        {
            key: "initialisePausedAdBreakSeekWorkaround",
            value: function initialisePausedAdBreakSeekWorkaround() {
                var _this = this;
                this.pausedAdBreakWorkaroundInterval = new SafeInterval({
                    executor: function() {
                        if (!_this.seeker) {
                            _this.logger.warn('Attempting paused ad break seek work around but seeker is not defined');
                            return;
                        }
                        _this.seeker.seek(_this.currentPosition);
                        _this.logger.verbose("Seeking to ".concat(_this.currentPosition, " (current position) to avoid suspension on Windows Edge"));
                    },
                    timeMs: MS_EDGE_PAUSE_BREAK_WORKAROUND_INTERVAL
                });
            }
        },
        {
            key: "handleMetadataEvent",
            value: /**
     * Emits scte35-related metadata events.
     * Other timed metadata events will be ignored here (for id3 and ad creative signaling, see SafariMetadataManager)
     */ function handleMetadataEvent(event) {
                var payload = event.payload;
                var hasScte35Data = payload && [
                    'SCTE35-IN',
                    'SCTE35-OUT',
                    'SCTE35-CMD'
                ].includes(payload.key);
                if (hasScte35Data) {
                    var scte35Data = stringOrUint8ToString(payload.data);
                    var timedMetadata = {
                        playerTime: event.startTime,
                        duration: event.endTime ? event.endTime - event.startTime : Infinity,
                        type: TimedMetadataType.HlsDaterange,
                        clientAttributes: {
                            scte35Data: scte35Data
                        },
                        id: "DateRange-".concat(scte35Data)
                    };
                    // Shaka doesn't seem to give us the actual ID -- this should be unique enough
                    this.notifyTimedMetadataReceived(timedMetadata);
                }
            }
        },
        {
            key: "handleDownloadHeadersReceived",
            value: function handleDownloadHeadersReceived(event) {
                this.lastHeaders = event.headers;
            }
        },
        {
            key: "nativeLoad",
            value: function nativeLoad(playoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_audioTracksManager, _playoutData_drmConfiguration, _this_stallDetector, _this_advertBoltOns_eventsManager, deviceInfo, deviceType, eventHandlers, _this_errorObservable, // Some devices (Xbox, Samsung) seem to have issues with the text display factory being configured _before_ the video element is attached to the DOM
                    // Hence we do this here and not in the PEI Precursor
                    _this_player, shakaTextFactoryConfig, error, _this_errorObservable1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.didLoadError = false;
                                (_this_audioTracksManager = _this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.resetCodecSwitch();
                                deviceInfo = CoreVideoInternal.deviceInfo, deviceType = CoreVideoInternal.deviceType;
                                if (isEdgeDesktop(deviceInfo, deviceType) && isWindows(deviceInfo.operatingSystemName) && ((_playoutData_drmConfiguration = playoutData.drmConfiguration) === null || _playoutData_drmConfiguration === void 0 ? void 0 : _playoutData_drmConfiguration.type) === DrmType.PlayReady) {
                                    _this.initialisePausedAdBreakSeekWorkaround();
                                }
                                _this.stateMachineManager = new ShakaStateMachineManager(playoutData.autoplay, function(state) {
                                    _this.tryPauseDuringBreaksWorkaround(state);
                                    _this.notifyStateChanged(state);
                                }, _this.internalRetryStatus.retryCount > 0);
                                eventHandlers = {
                                    type: PlayerType.Shaka,
                                    onPlayerAvailable: _this.handlePlayerAvailableFromPrecursor.bind(_this),
                                    onManifestAvailable: function() {
                                        var _this_adBreaksProvider;
                                        (_this_adBreaksProvider = _this.adBreaksProvider) === null || _this_adBreaksProvider === void 0 ? void 0 : _this_adBreaksProvider.onParsedManifest();
                                    },
                                    onLoadError: function(e) {
                                        var _this_errorObservable;
                                        // If the PEI Load failed during prefetch this function will get called
                                        // as soon as we attach the event handlers
                                        if (e.severity === ErrorSeverity.Fatal) {
                                            _this.didLoadError = true;
                                        }
                                        (_this_errorObservable = _this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.notifyObservers(e);
                                    },
                                    onSubtitleCuesChanged: _this.notifySubtitleCuesChanged.bind(_this),
                                    onLoading: _this.stateMachineManager.setLoading.bind(_this),
                                    onLoaded: _this.handleLoaded.bind(_this),
                                    onBuffering: _this.handleBuffering.bind(_this),
                                    onAdaptation: _this.adaptationHandler.bind(_this),
                                    onMediaQualityChanged: _this.onMediaQualityChangedHandler.bind(_this),
                                    onError: _this.errorHandler.bind(_this),
                                    onTracksChanged: _this.tracksChangedHandler.bind(_this),
                                    onTextTracksChanged: _this.handleTextTrackChanged.bind(_this),
                                    onEsmg: _this.emsgHandler.bind(_this),
                                    onPrft: _this.prftHandler.bind(_this),
                                    onVariantChangeRequested: _this.variantChangeRequestedHandler.bind(_this),
                                    onVariantChangeActuated: _this.variantChangeActuatedHandler.bind(_this),
                                    onTimelineRegionAdded: _this.timelineRegionAddedHandler.bind(_this),
                                    onLargeGapDetected: _this.largeGapDetectedHandler.bind(_this),
                                    onManifestParsed: _this.handleManifestParsed.bind(_this),
                                    onTimeUpdate: _this.handleTimeUpdate.bind(_this),
                                    onPause: _this.handlePause.bind(_this),
                                    onPlaying: _this.handlePlaying.bind(_this),
                                    onEnded: _this.stateMachineManager.setFinished.bind(_this),
                                    onSeekStarted: _this.handleSeekStarted.bind(_this),
                                    onSeekEnded: _this.handleSeeked.bind(_this),
                                    onDurationChanged: _this.durationChangeHandler.bind(_this),
                                    onCanPlayThrough: _this.canPlayThrough.bind(_this),
                                    onVideoElementCreated: _this.videoElementCreated.bind(_this),
                                    onPlayError: _this.handleAutoplayError.bind(_this),
                                    onFullscreenChanged: _this.handleFullscreenChanged.bind(_this),
                                    onClicked: _this.handleClicked.bind(_this),
                                    onSegmentDownloaded: _this.handleSegmentDownloaded.bind(_this),
                                    onPlay: _this.handlePlay.bind(_this),
                                    onManifestUpdated: _this.handleManifestUpdated.bind(_this),
                                    onMetadata: _this.handleMetadataEvent.bind(_this),
                                    onDownloadHeadersReceived: _this.handleDownloadHeadersReceived.bind(_this)
                                };
                                try {
                                    _this.precursor.peiLoadStart(eventHandlers);
                                } catch (error) {
                                    ;
                                    (_this_errorObservable = _this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.notifyObservers(ShakaPlayerError.playerLoadError({
                                        error: error
                                    }));
                                }
                                (_this_stallDetector = _this.stallDetector) === null || _this_stallDetector === void 0 ? void 0 : _this_stallDetector.externalDependencies({
                                    captureStats: _this.captureStats.bind(_this)
                                });
                                (_this_advertBoltOns_eventsManager = _this.advertBoltOns.eventsManager) === null || _this_advertBoltOns_eventsManager === void 0 ? void 0 : _this_advertBoltOns_eventsManager.onAdBreakFinished(_this.handleAdBreakFinished, _this);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.precursor.load({
                                        autoplay: playoutData.autoplay,
                                        isCalledFromPei: true
                                    })
                                ];
                            case 2:
                                _state.sent();
                                if (!_this.isSafariSrcEquals) {
                                    ;
                                    // Observed that on Safari the textDisplayFactory is ignored and shaka only uses a internal subtitle object
                                    // The problem is that when it's on safari shaka destroy this object, and to prevent it we only set this property when it's not on safari.
                                    // https://github.com/google/shaka-player/issues/2585
                                    shakaTextFactoryConfig = {};
                                    shakaTextFactoryConfig.textDisplayFactory = function() {
                                        return _this.textDisplayer;
                                    };
                                    (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.configure(shakaTextFactoryConfig);
                                }
                                _this.debugData.startTime = new Date().toLocaleTimeString();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                (_this_errorObservable1 = _this.errorObservable) === null || _this_errorObservable1 === void 0 ? void 0 : _this_errorObservable1.notifyObservers(ShakaPlayerError.playerLoadError({
                                    error: error
                                }));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "nativeSeek",
            value: function nativeSeek(positionSeconds) {
                var _this_stateMachineManager, _this_textDisplayer;
                var wasWorkaroundExecuted = this.endOfStreamWorkaround(positionSeconds);
                if (wasWorkaroundExecuted) {
                    return positionSeconds;
                }
                (_this_stateMachineManager = this.stateMachineManager) === null || _this_stateMachineManager === void 0 ? void 0 : _this_stateMachineManager.setSeeking();
                // set to seeking BEFORE we start the internal workarounds
                var safePosition = this.seeker.seek(positionSeconds);
                (_this_textDisplayer = this.textDisplayer) === null || _this_textDisplayer === void 0 ? void 0 : _this_textDisplayer.notifySeekStarted();
                return safePosition;
            }
        },
        {
            key: "nativePlay",
            value: function nativePlay() {
                var _this_videoElement;
                (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.play();
            }
        },
        {
            key: "nativePause",
            value: function nativePause() {
                var _this_videoElement;
                (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.pause();
            }
        },
        {
            key: "nativeStop",
            value: function nativeStop() {
                try {
                    var _this_postAdBreakCorrectiveSeekTimer, _this_pausedAdBreakWorkaroundInterval, _this_textTracksManager, _this_seeker, _this_textDisplayer, _this_advertBoltOns_eventsManager;
                    (_this_postAdBreakCorrectiveSeekTimer = this.postAdBreakCorrectiveSeekTimer) === null || _this_postAdBreakCorrectiveSeekTimer === void 0 ? void 0 : _this_postAdBreakCorrectiveSeekTimer.destroy();
                    (_this_pausedAdBreakWorkaroundInterval = this.pausedAdBreakWorkaroundInterval) === null || _this_pausedAdBreakWorkaroundInterval === void 0 ? void 0 : _this_pausedAdBreakWorkaroundInterval.stop();
                    (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.destroy();
                    (_this_seeker = this.seeker) === null || _this_seeker === void 0 ? void 0 : _this_seeker.destroy();
                    this.seeker = undefined;
                    this.removeShakaEventHandlers();
                    this.removeVideoElement();
                    this.closeMediaKeySessions();
                    (_this_textDisplayer = this.textDisplayer) === null || _this_textDisplayer === void 0 ? void 0 : _this_textDisplayer.destroy();
                    (_this_advertBoltOns_eventsManager = this.advertBoltOns.eventsManager) === null || _this_advertBoltOns_eventsManager === void 0 ? void 0 : _this_advertBoltOns_eventsManager.removeEventListeners(this);
                } finally{
                    if (this.stateMachineManager) {
                        this.stateMachineManager.destroy();
                    } else {
                        this.notifyStateChanged(PlayerState.Stopped);
                    }
                }
            }
        },
        {
            key: "nativeSetVolume",
            value: function nativeSetVolume(volume) {
                this.videoElement.volume = volume;
                this.notifyVolumeChanged(volume);
            }
        },
        {
            key: "nativeMute",
            value: function nativeMute() {
                this.videoElement.muted = true;
                this.notifyMuteChanged(true);
            }
        },
        {
            key: "nativeUnmute",
            value: function nativeUnmute() {
                this.videoElement.muted = false;
                this.notifyMuteChanged(false);
            }
        },
        {
            key: "nativeSetPlayerBitrateLimits",
            value: function nativeSetPlayerBitrateLimits(playerBitrateLimits) {
                var _this_player;
                if (!this.player) {
                    this.logger.warn('Player has not yet been loaded. Cannot set bitrate limits');
                    return;
                }
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.configure({
                    abr: {
                        restrictions: {
                            maxBandwidth: playerBitrateLimits.maxBitRate,
                            minBandwidth: playerBitrateLimits.minBitRate
                        }
                    }
                });
                return;
            }
        },
        {
            key: "nativeResetPlayerBitrateLimits",
            value: function nativeResetPlayerBitrateLimits() {
                var _this_player;
                if (!this.player) {
                    this.logger.warn('Player has not yet been loaded. Cannot set bitrate limits');
                    return;
                }
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.configure({
                    abr: {
                        restrictions: {
                            maxBandwidth: Infinity,
                            minBandwidth: 0
                        }
                    }
                });
                return;
            }
        },
        {
            key: "nativeDisableSubtitles",
            value: function nativeDisableSubtitles() {
                // This is used as a wrapper to allow for an alternative signature when called internally
                this._nativeDisableSubtitles();
            }
        },
        {
            key: "nativeEnableSubtitles",
            value: function nativeEnableSubtitles(trackId) {
                var _this_textTracksManager;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.enableSubtitles(trackId);
            }
        },
        {
            key: "notifyAudioTrackChanged",
            value: function notifyAudioTrackChanged(trackId) {
                var _this_textTracksManager;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.toggleForcedTextTrack();
                _get(_get_prototype_of(ShakaPlayerEngineItem.prototype), "notifyAudioTrackChanged", this).call(this, trackId);
            }
        },
        {
            key: "getAudioTrackChangeSafeMargin",
            value: function getAudioTrackChangeSafeMargin() {
                var tracksConfig = getTracksConfig(this.playoutData);
                if (tracksConfig && tracksConfig.audioTracksSwitchSafeMarginSeconds && tracksConfig.audioTracksSwitchSafeMarginSeconds > 0) {
                    return tracksConfig.audioTracksSwitchSafeMarginSeconds;
                }
                return 0;
            }
        },
        {
            key: "nativeSetAudioTrack",
            value: function nativeSetAudioTrack(audioTrackId) {
                if (this.playerEngineOptions.isMultiview && this.playerConfig.deferMultiviewSetAudioTrackWhileLoading) {
                    switch(this.state){
                        case PlayerState.WaitingToLoad:
                        case PlayerState.Loading:
                            // Defer this call until later
                            this.logger.warn("setAudioTrack('".concat(audioTrackId, "') detected while player was loading and deferMultiviewSetAudioTrackWhileLoading was enabled. Deferring call until Playing state is reached. Previous calls will be ignored."));
                            this.deferredSetAudioCall = audioTrackId;
                            return;
                        default:
                    }
                }
                try {
                    var _this_audioTracksManager;
                    (_this_audioTracksManager = this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.setAudioTrack(audioTrackId, this.audioTracksSwitchSafeMarginSeconds);
                    this.handlePossibleNewActiveVariant();
                } // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Type of error is not known. Checked during runtime.
                catch (e) {
                    if (_instanceof(e, CvsdkError)) {
                        this.notifyError(e);
                    } else {
                        var _e_response;
                        this.notifyError(CvsdkError.from({
                            code: e.code || 'SHAKA_SET_AUDIO_TRACK_FAIL',
                            message: e.description || ((_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.statusText) || e.message || JsonUtils.stringify(e),
                            severity: ErrorSeverity.Fatal,
                            cause: e
                        }));
                    }
                }
            }
        },
        {
            key: "captureStats",
            value: function captureStats() {
                var _this_debugData_playoutData, _this_debugData_playoutData1, _document;
                var stats = {};
                stats['session.startTime'] = this.debugData.startTime;
                stats['session.endTime'] = new Date().toLocaleTimeString();
                stats['session.manifestUrl'] = (_this_debugData_playoutData = this.debugData.playoutData) === null || _this_debugData_playoutData === void 0 ? void 0 : _this_debugData_playoutData.manifestUrl;
                stats['session.drmConfig'] = JsonUtils.stringify((_this_debugData_playoutData1 = this.debugData.playoutData) === null || _this_debugData_playoutData1 === void 0 ? void 0 : _this_debugData_playoutData1.drmConfig);
                stats['document.visibility'] = (_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState;
                if (this.videoElement) {
                    stats['video.currentTime'] = this.videoElement.currentTime;
                    if (this.videoElement.buffered) {
                        var rangeCount = this.videoElement.buffered.length;
                        var ranges = [];
                        for(var i = 0; i < rangeCount; i++){
                            var range = "[".concat(this.videoElement.buffered.start(i).toFixed(3), "-").concat(this.videoElement.buffered.end(i).toFixed(3), "]");
                            ranges.push(range);
                        }
                        stats['video.buffered'] = ranges;
                    }
                    stats['video.bitrateLevel'] = this.bitRateLevel;
                    stats['video.readyState'] = this.videoElement.readyState;
                    stats['video.playbackRate'] = this.videoElement.playbackRate;
                    stats['video.paused'] = this.videoElement.paused;
                    stats['video.ended'] = this.videoElement.ended;
                    stats['video.error'] = this.videoElement.error;
                    stats['video.seeking'] = this.videoElement.seeking;
                    stats['video.isMuted'] = this.videoElement.muted;
                }
                if (this.player) {
                    stats['shaka.stats'] = this.player.getStats();
                    stats['shaka.isBuffering'] = this.player.isBuffering();
                    stats['shaka.getBufferedInfo'] = this.player.getBufferedInfo();
                }
                return stats;
            }
        },
        {
            key: "handlePlayerAvailableFromPrecursor",
            value: function handlePlayerAvailableFromPrecursor(player, isInternalRetryEnabled) {
                var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig, _CoreVideoInternal_getPropositionExtensions, _this_thumbnailManager;
                this.player = player;
                var _this_playerEngineOptions_optimiseAudioTracksByLanguage;
                this.audioTracksManager = new ShakaAudioTracksManager(player, {
                    optimiseAudioTracksByLanguage: (_this_playerEngineOptions_optimiseAudioTracksByLanguage = this.playerEngineOptions.optimiseAudioTracksByLanguage) !== null && _this_playerEngineOptions_optimiseAudioTracksByLanguage !== void 0 ? _this_playerEngineOptions_optimiseAudioTracksByLanguage : true,
                    isMultiview: Boolean(this.playerEngineOptions.isMultiview),
                    isSafari: this.isSafariSrcEquals,
                    omitRegionCodeFromAudioTrack: this.omitRegionCodeFromAudioTrack
                });
                var textTracksManagerConfig = {
                    getActiveAudioTrack: this.audioTracksManager.getActiveAudioTrack.bind(this.audioTracksManager),
                    textDisplayer: this.textDisplayer,
                    notifySubtitlesTrackChanged: this.notifySubtitlesTrackChanged.bind(this),
                    notifySubtitlesTracksChanged: this.notifyAvailableSubtitlesTracksChanged.bind(this),
                    clearSubtitles: this.clearSubtitles.bind(this),
                    isMultiview: Boolean(this.playerEngineOptions.isMultiview)
                };
                var propositionExtensionsShaka = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig = _CoreVideoInternal_getPropositionExtensions.propositionPlayerConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig[PlayerType.Shaka];
                this.textTracksManager = this.isSafariSrcEquals ? new SafariShakaTextTracksManager(this.player, _object_spread_props(_object_spread({}, textTracksManagerConfig), {
                    webVttOverride: Boolean(propositionExtensionsShaka === null || propositionExtensionsShaka === void 0 ? void 0 : propositionExtensionsShaka.safariTextTrackTypeWebVTTOverride),
                    convertTextTrackLangsTo3Letter: Boolean(propositionExtensionsShaka === null || propositionExtensionsShaka === void 0 ? void 0 : propositionExtensionsShaka.convertTextTrackLangsTo3Letter)
                })) : new ShakaTextTracksManager(this.player, textTracksManagerConfig);
                this.internalRetryStatus.enabled = isInternalRetryEnabled;
                var hasMediaKeysData = !!this.internalRetryStatus.mediaKeys && !!this.internalRetryStatus.activeSessions;
                var drmData = !!this.playoutData.drmConfiguration && hasMediaKeysData;
                if (drmData && isInternalRetryEnabled) {
                    var _this_player_registerMediaKeysData, _this_player;
                    (_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_registerMediaKeysData = _this_player.registerMediaKeysData) === null || _this_player_registerMediaKeysData === void 0 ? void 0 : _this_player_registerMediaKeysData.call(_this_player, this.internalRetryStatus.mediaKeys, this.internalRetryStatus.activeSessions);
                }
                (_this_thumbnailManager = this.thumbnailManager) === null || _this_thumbnailManager === void 0 ? void 0 : _this_thumbnailManager.providePlayer(this.player);
            }
        },
        {
            key: "closeMediaKeySessions",
            value: function closeMediaKeySessions() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player_getMediaKeysData, _this_player, drmData, activeSessions, openSessions;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.internalRetryStatus.enabled) {
                                    return [
                                        2
                                    ];
                                }
                                drmData = !!_this.playoutData.drmConfiguration && ((_this_player = _this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getMediaKeysData = _this_player.getMediaKeysData) === null || _this_player_getMediaKeysData === void 0 ? void 0 : _this_player_getMediaKeysData.call(_this_player));
                                if (!drmData) {
                                    return [
                                        2
                                    ];
                                }
                                activeSessions = drmData.activeSessions;
                                openSessions = Array.from(activeSessions.keys());
                                return [
                                    4,
                                    allSettled(openSessions.map(function(s) {
                                        return s.close();
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _this.internalRetryStatus.mediaKeys = undefined;
                                _this.internalRetryStatus.activeSessions = undefined;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setTextTrack",
            value: function setTextTrack(track) {
                var _this_textTracksManager;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.setTextTrack(track);
            }
        },
        {
            key: "getVideoContainer",
            value: function getVideoContainer() {
                var _this_playerEngineOptions_videoHtmlContainerInfo, _this_playerEngineOptions;
                return (_this_playerEngineOptions = this.playerEngineOptions) === null || _this_playerEngineOptions === void 0 ? void 0 : (_this_playerEngineOptions_videoHtmlContainerInfo = _this_playerEngineOptions.videoHtmlContainerInfo) === null || _this_playerEngineOptions_videoHtmlContainerInfo === void 0 ? void 0 : _this_playerEngineOptions_videoHtmlContainerInfo.videoHTMLContainer;
            }
        },
        {
            key: "setDefaultVideoStyle",
            value: function setDefaultVideoStyle() {
                this.videoElement.style.display = 'initial';
                this.videoElement.style.width = '100%';
                this.videoElement.style.height = '100%';
                this.videoElement.style.zIndex = '-1';
                this.disableSafariNativeSubtitles();
            }
        },
        {
            key: "disableSafariNativeSubtitles",
            value: function disableSafariNativeSubtitles() {
                var disablingSafariNativeSubtitlesElement = document.getElementById(SAFARI_NATIVE_SUBTITLES_STYLE_ID);
                if (this.isSafariSrcEquals && !disablingSafariNativeSubtitlesElement) {
                    // Workaround to disable the native subtitle component on safari
                    // https://github.com/google/shaka-player/issues/2585
                    var style = document.createElement('style');
                    style.id = SAFARI_NATIVE_SUBTITLES_STYLE_ID;
                    style.innerHTML = SAFARI_NATIVE_SUBTITLES_STYLE_CONTENT;
                    document.getElementsByTagName('head')[0].appendChild(style);
                }
            }
        },
        {
            key: "initAndAppendVideoElement",
            value: function initAndAppendVideoElement(containerElement, playoutData) {
                if (!this.videoElement) {
                    throw new Error('Missing video element!');
                }
                if (typeof playoutData.volume === 'number') {
                    this.videoElement.volume = playoutData.volume;
                }
                containerElement.appendChild(this.videoElement);
            }
        },
        {
            key: "removeVideoElement",
            value: function removeVideoElement() {
                if (this.videoElement) {
                    var _this_videoElement_parentElement;
                    this.videoElement.removeEventListener('canplaythrough', this.onCodecSwitchEnded);
                    (_this_videoElement_parentElement = this.videoElement.parentElement) === null || _this_videoElement_parentElement === void 0 ? void 0 : _this_videoElement_parentElement.removeChild(this.videoElement);
                    this.videoElement = null;
                }
            }
        },
        {
            key: "injectHeaderParameters",
            value: function injectHeaderParameters(shakeError) {
                var _shakeError_parameters;
                if (this.lastHeaders && !((_shakeError_parameters = shakeError.parameters) === null || _shakeError_parameters === void 0 ? void 0 : _shakeError_parameters.responseHeaders)) {
                    // Inject most recently available headers (avoids replacing headers associated with the actual error)
                    shakeError.parameters = _object_spread_props(_object_spread({}, shakeError.parameters), {
                        responseHeaders: JsonUtils.stringify(this.lastHeaders)
                    });
                }
            }
        },
        {
            key: "addShakaEventHandlers",
            value: function addShakaEventHandlers() {
                var _this_player_getNetworkingEngine, _this_player, _this_safariMetadataManager;
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getNetworkingEngine = _this_player.getNetworkingEngine()) === null || _this_player_getNetworkingEngine === void 0 ? void 0 : _this_player_getNetworkingEngine.addEventListener('retry', this.handleRetryError);
                (_this_safariMetadataManager = this.safariMetadataManager) === null || _this_safariMetadataManager === void 0 ? void 0 : _this_safariMetadataManager.addListeners();
            }
        },
        {
            key: "removeShakaEventHandlers",
            value: function removeShakaEventHandlers() {
                var _this_player_getNetworkingEngine, _this_player, _this_safariMetadataManager;
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getNetworkingEngine = _this_player.getNetworkingEngine()) === null || _this_player_getNetworkingEngine === void 0 ? void 0 : _this_player_getNetworkingEngine.removeEventListener('retry', this.handleRetryError);
                (_this_safariMetadataManager = this.safariMetadataManager) === null || _this_safariMetadataManager === void 0 ? void 0 : _this_safariMetadataManager.removeListeners();
            }
        },
        {
            key: "getVariantTracks",
            value: function getVariantTracks(config) {
                if (config === null || config === void 0 ? void 0 : config.refresh) {
                    this.variantTracks = [];
                }
                if (this.variantTracks && this.variantTracks.length > 0) {
                    return this.variantTracks;
                }
                this.variantTracks = this.player.getVariantTracks();
                return this.variantTracks;
            }
        },
        {
            key: "getActiveTextTrack",
            value: function getActiveTextTrack() {
                var _this_player;
                return (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getTextTracks().find(function(track) {
                    return track.active;
                });
            }
        },
        {
            key: "handleSubtitleTracksChanges",
            value: function handleSubtitleTracksChanges() {
                var _this_textTracksManager;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.handleTracksChanged();
            }
        },
        {
            key: "updateShakaPreferredTextTracks",
            value: /**
     * Updates cached text tracks in ShakaTextTracksManager and then selects preferred subtitle language for Shaka config.
     * This must be called on the manifestParsed event for Shaka, and on the tracksChanged event for Safari native player - otherwise, the config changes are too late for the player to apply.
     * (Safari native player fires tracksChanged events before the manifestParsed event, unlike Shaka player)
     */ function updateShakaPreferredTextTracks() {
                var _this_textTracksManager, _this_playoutData_preferredSubtitleMetadata, _this_playoutData_preferredSubtitlesLanguages;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.updateCachedTextTracks();
                if (((_this_playoutData_preferredSubtitleMetadata = this.playoutData.preferredSubtitleMetadata) === null || _this_playoutData_preferredSubtitleMetadata === void 0 ? void 0 : _this_playoutData_preferredSubtitleMetadata.length) || ((_this_playoutData_preferredSubtitlesLanguages = this.playoutData.preferredSubtitlesLanguages) === null || _this_playoutData_preferredSubtitlesLanguages === void 0 ? void 0 : _this_playoutData_preferredSubtitlesLanguages.length)) {
                    var _this_playoutData_preferredSubtitleMetadata1, _this_playoutData_preferredSubtitlesLanguages1, _this_textTracksManager1;
                    var preferredLanguages = [];
                    if ((_this_playoutData_preferredSubtitleMetadata1 = this.playoutData.preferredSubtitleMetadata) === null || _this_playoutData_preferredSubtitleMetadata1 === void 0 ? void 0 : _this_playoutData_preferredSubtitleMetadata1.length) {
                        preferredLanguages = this.playoutData.preferredSubtitleMetadata.map(function(psm) {
                            return psm.languageTag;
                        });
                    } else if ((_this_playoutData_preferredSubtitlesLanguages1 = this.playoutData.preferredSubtitlesLanguages) === null || _this_playoutData_preferredSubtitlesLanguages1 === void 0 ? void 0 : _this_playoutData_preferredSubtitlesLanguages1.length) {
                        preferredLanguages = this.playoutData.preferredSubtitlesLanguages;
                    }
                    (_this_textTracksManager1 = this.textTracksManager) === null || _this_textTracksManager1 === void 0 ? void 0 : _this_textTracksManager1.detectAndSetShakaPreferredLanguage(preferredLanguages);
                }
            }
        },
        {
            key: "handleAudioTracksChanged",
            value: function handleAudioTracksChanged() {
                var forceTrackActuation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this_audioTracksManager, _this_audioTracksManager1;
                var _this_audioTracksManager_buildReducedAudioTrackList;
                var reducedTracks = (_this_audioTracksManager_buildReducedAudioTrackList = (_this_audioTracksManager = this.audioTracksManager) === null || _this_audioTracksManager === void 0 ? void 0 : _this_audioTracksManager.buildReducedAudioTrackList()) !== null && _this_audioTracksManager_buildReducedAudioTrackList !== void 0 ? _this_audioTracksManager_buildReducedAudioTrackList : [];
                this.notifyAvailableAudioTracksChanged(reducedTracks);
                /**
         * Should not fire notify audio track changed here as it will be fired
         * by "audiotrackchanged" shaka event when the audio is really changed
         * for the end user. The only moment we except that is for the first
         * time handleAudioTracksChanged fires, as the "audiotrackchanged" doesn't
         * fires for the first audio track we need to let it continue here
         * in order to notify the first audio track selected.
         */ if (this.playerEngineOptions.isMultiview && !this.lastActiveVariant_ && !forceTrackActuation) return;
                var activeAudioTrack = (_this_audioTracksManager1 = this.audioTracksManager) === null || _this_audioTracksManager1 === void 0 ? void 0 : _this_audioTracksManager1.getActiveAudioTrackId();
                if (activeAudioTrack) {
                    this.notifyAudioTrackChanged(activeAudioTrack);
                    return;
                }
                // Should never get here but in any case selects the first available audio track.
                if (reducedTracks.length > 0) {
                    this.notifyAudioTrackChanged(reducedTracks[0].id);
                }
            }
        },
        {
            key: "isRetryTimeLimitExceeded",
            value: function isRetryTimeLimitExceeded() {
                var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka, _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig;
                var internalRetryTimeLimitMinutes = (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig = CoreVideoInternal.getPropositionExtensions().propositionPlayerConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka = _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig[PlayerType.Shaka]) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka.internalRetryTimeLimitMinutes;
                if (internalRetryTimeLimitMinutes && this.internalRetryStatus.startTime + internalRetryTimeLimitMinutes * 60 * 1000 < Date.now()) {
                    this.logger.warn("Can't perform internal retry after ".concat(internalRetryTimeLimitMinutes, " minutes"));
                    return true;
                }
                return false;
            }
        },
        {
            key: "shouldInternalRetryFromError",
            value: function shouldInternalRetryFromError(event) {
                var _this_playerConfig_internalRetryConfig, _this_playerConfig, _this_playerConfig_internalRetryConfig1;
                var errorCode = event.detail.code;
                var errorDetail;
                switch(errorCode){
                    case 3017:
                        errorDetail = 'QUOTA_EXCEEDED_ERROR';
                        break;
                    case 3016:
                        errorDetail = 'VIDEO_ERROR';
                        break;
                    default:
                        return false;
                }
                var cooloffPeriodMinutes = ((_this_playerConfig = this.playerConfig) === null || _this_playerConfig === void 0 ? void 0 : (_this_playerConfig_internalRetryConfig = _this_playerConfig.internalRetryConfig) === null || _this_playerConfig_internalRetryConfig === void 0 ? void 0 : _this_playerConfig_internalRetryConfig.retryCooloffTimeMinutes) || DEFAULT_INTERNAL_RETRY_COOLDOWN_TIME_MINUTES;
                if (this.internalRetryStatus.lastAttemptedRetry + cooloffPeriodMinutes * 60 * 1000 < Date.now()) {
                    this.internalRetryStatus.retryCount = 0;
                }
                var maxRetryAttempts = ((_this_playerConfig_internalRetryConfig1 = this.playerConfig.internalRetryConfig) === null || _this_playerConfig_internalRetryConfig1 === void 0 ? void 0 : _this_playerConfig_internalRetryConfig1.maxRetryAttempts) || DEFAULT_MAX_INTERNAL_RETRY_ATTEMPTS;
                if (this.internalRetryStatus.retryCount > maxRetryAttempts) {
                    return false;
                }
                if (this.isRetryTimeLimitExceeded()) {
                    return false;
                }
                this.notifyWarning(CvsdkError.from({
                    code: 'SDK.SHAKA.INTERNAL_RETRY',
                    message: "".concat(errorCode, " ").concat(errorDetail, " occurred - attempting internal retry"),
                    severity: ErrorSeverity.Warning,
                    cause: event.detail.data
                }));
                return true;
            }
        },
        {
            key: "_nativeDisableSubtitles",
            value: function _nativeDisableSubtitles() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    hasAlreadyToggledForcedNarrative: false,
                    shouldEnableForcedTextTrack: true
                }, _ref_hasAlreadyToggledForcedNarrative = _ref.hasAlreadyToggledForcedNarrative, hasAlreadyToggledForcedNarrative = _ref_hasAlreadyToggledForcedNarrative === void 0 ? false : _ref_hasAlreadyToggledForcedNarrative, _ref_shouldEnableForcedTextTrack = _ref.shouldEnableForcedTextTrack, shouldEnableForcedTextTrack = _ref_shouldEnableForcedTextTrack === void 0 ? true : _ref_shouldEnableForcedTextTrack;
                var _this_textTracksManager;
                (_this_textTracksManager = this.textTracksManager) === null || _this_textTracksManager === void 0 ? void 0 : _this_textTracksManager.disableSubtitles({
                    hasAlreadyToggledForcedNarrative: hasAlreadyToggledForcedNarrative,
                    enableForcedTrack: shouldEnableForcedTextTrack
                });
            }
        },
        {
            key: "tizenPrerollWorkaround",
            value: /**
     * Workaround for issue seen when starting playback on unencrypted content
     * Ticket https://github.com/sky-uk/core-video-team/issues/5575
     */ function tizenPrerollWorkaround() {
                var _this = this;
                return _async_to_generator(function() {
                    var originalStartPosition, _this_player, contentStartPosition, originalAutoplay, hasPreroll, _this_videoElement_style, width, height, position, mediaElement;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                originalStartPosition = Math.floor(_this.playoutData.position || 0);
                                if (!(_this.adBreakTimeAdapter && checkIsManifestVodType(_this.playoutData.type) && checkIsTizenVersion(CoreVideoInternal.deviceInfo, TizenVersion['Tizen-3']) && !originalStartPosition)) return [
                                    3,
                                    7
                                ];
                                // If position changed when adapting, that means there is a preroll so let's change the startPosition to this
                                contentStartPosition = _this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(0.1);
                                originalAutoplay = Boolean(_this.playoutData.autoplay);
                                hasPreroll = contentStartPosition > 0.1;
                                if (!hasPreroll) {
                                    return [
                                        2
                                    ];
                                }
                                // Set to start playing at actual content
                                // Shaka PEI Precursor will do this
                                // Once the player starts loading, shrink the video and mute it
                                return [
                                    4,
                                    _this.waitForState(PlayerState.Loading)
                                ];
                            case 1:
                                _state.sent();
                                _this.shouldIgnoreStateAndPositionChanges = true;
                                _this_videoElement_style = _this.videoElement.style, width = _this_videoElement_style.width, height = _this_videoElement_style.height, position = _this_videoElement_style.position;
                                _this.videoElement.style.width = '0.5%';
                                _this.videoElement.style.height = '0.5%';
                                _this.videoElement.muted = true;
                                return [
                                    4,
                                    _this.waitForNonGatedState(PlayerState.Playing)
                                ];
                            case 2:
                                _state.sent();
                                mediaElement = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.getMediaElement();
                                mediaElement.currentTime = 0;
                                return [
                                    4,
                                    _this.waitForNonGatedState(PlayerState.Playing)
                                ];
                            case 3:
                                _state.sent();
                                if (!originalAutoplay) return [
                                    3,
                                    4
                                ];
                                mediaElement.pause();
                                mediaElement.play();
                                _this.shouldIgnoreStateAndPositionChanges = false;
                                _this.notifyStateChanged(PlayerState.Playing);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                mediaElement.pause();
                                // wait at most 1s for false playing state emitted on samsung 3.0
                                return [
                                    4,
                                    Promise.race([
                                        _this.waitForNonGatedState(PlayerState.Playing),
                                        new Promise(function(r) {
                                            return setTimeout(r, 1000);
                                        })
                                    ])
                                ];
                            case 5:
                                _state.sent();
                                _this.shouldIgnoreStateAndPositionChanges = false;
                                mediaElement.pause();
                                _state.label = 6;
                            case 6:
                                _this.videoElement.style.width = width;
                                _this.videoElement.style.height = height;
                                _this.videoElement.style.position = position;
                                _this.videoElement.muted = _this.isCurrentlyMuted;
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tizenBufferingWorkaround",
            value: /**
     * Workaround for issue seen when buffering on preroll ad break
     * Ticket https://github.com/sky-uk/core-video-team/issues/8396
     */ function tizenBufferingWorkaround() {
                var originalStartPosition = this.playoutData.position || 0;
                if (checkIsTizenVersion(CoreVideoInternal.deviceInfo, TizenVersion['Tizen-5.5']) && !originalStartPosition) {
                    if (this.state === PlayerState.Rebuffering && checkIsManifestVodType(this.playoutData.type)) {
                        // force a seek to currentTime
                        this.videoElement.currentTime = this.videoElement.currentTime;
                    }
                    if (this.state === PlayerState.Loading && checkIsManifestLinearType(this.playoutData.type)) {
                        this.applyingTizenBufferingWorkaround = true;
                        // force a seek to currentTime
                        this.videoElement.currentTime = this.videoElement.currentTime;
                    }
                }
            }
        },
        {
            key: "endOfStreamWorkaround",
            value: function endOfStreamWorkaround(seekPosition) {
                var _this = this;
                var _this_videoElement, _this_videoElement1;
                if (CoreVideoInternal.deviceType === DeviceType.MultiChoiceRdk && ((_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.buffered.length) === 1 && ((_this_videoElement1 = this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.buffered.end(0)) === this.videoElement.duration) {
                    this.currentPosition = seekPosition;
                    this.notifyStateChanged(PlayerState.Seeking);
                    this.shouldIgnoreStateAndPositionChanges = true;
                    this.notifyWarning(CvsdkError.from({
                        code: 'SDK.SHAKA.INTERNAL_RETRY',
                        message: "Seek after EndOfStream was called - Executing Shaka Internal Retry as workaround",
                        severity: ErrorSeverity.Warning
                    }));
                    this.handleInternalRetry();
                    this.waitForNonGatedState(PlayerState.Playing).then(function() {
                        _this.shouldIgnoreStateAndPositionChanges = false;
                        _this.notifyStateChanged(PlayerState.Playing);
                    });
                    return true;
                }
                return false;
            }
        },
        {
            key: "netgemLoadingWorkaround",
            value: function netgemLoadingWorkaround() {
                if (this.state === PlayerState.Loading && this.videoElement.currentTime) {
                    this.videoElement.currentTime = this.videoElement.currentTime;
                }
            }
        },
        {
            key: "installPostAdBreakSeek",
            value: function installPostAdBreakSeek(adBreak, config) {
                var _this = this;
                if (this.postAdBreakCorrectiveSeekTimer) {
                    this.logger.warn('Starting post ad-break seek timer while another is already active. Destroying old timer.');
                    this.postAdBreakCorrectiveSeekTimer.destroy();
                }
                if (adBreak.type === config.adType || !config.adType) {
                    this.postAdBreakCorrectiveSeekTimer = new SimpleTimer();
                    var _config_delayMs;
                    this.postAdBreakCorrectiveSeekTimer.start({
                        timeMs: (_config_delayMs = config.delayMs) !== null && _config_delayMs !== void 0 ? _config_delayMs : 1000,
                        callback: function() {
                            _this.logger.info('Executing post Ad Break corrective seek');
                            _this.videoElement.currentTime = _this.videoElement.currentTime;
                            _this.postAdBreakCorrectiveSeekTimer.destroy();
                            _this.postAdBreakCorrectiveSeekTimer = null;
                        }
                    });
                }
            }
        },
        {
            key: "tryPauseDuringBreaksWorkaround",
            value: // This work-around addresses an issue when pausing during an ad break on Windows Edge.
            // After 15s paused it would suspend the player and then run into a decoder issue once the break finishes after resuming.
            // This work-around prevents that suspension from happening by interacting with the player periodically.
            function tryPauseDuringBreaksWorkaround(state) {
                if (!this.pausedAdBreakWorkaroundInterval) {
                    return;
                }
                if (state === PlayerState.Paused) {
                    var _this_adBreakTimeAdapter;
                    if ((_this_adBreakTimeAdapter = this.adBreakTimeAdapter) === null || _this_adBreakTimeAdapter === void 0 ? void 0 : _this_adBreakTimeAdapter.isCurrentlyInAdBreak(this.currentPosition)) {
                        this.pausedAdBreakWorkaroundInterval.start();
                    }
                } else {
                    this.pausedAdBreakWorkaroundInterval.stop();
                }
            }
        },
        {
            key: "playerBufferingAndLoadingWorkaround",
            value: function playerBufferingAndLoadingWorkaround() {
                switch(CoreVideoInternal.deviceType){
                    case DeviceType.Netgem:
                        return this.netgemLoadingWorkaround();
                    case DeviceType.Tizen:
                        return this.tizenBufferingWorkaround();
                    default:
                        return null;
                }
            }
        },
        {
            key: "initSeeker",
            value: /**
     * Determines which parts of the Seeker to use based on device/player information
     * Creates new Shaka Seeker with that config
     * @param playoutData Player Playout Data containing the playback type
     */ function initSeeker(playoutData) {
                var _this_player_drmInfo, _this_playerConfig_seeker;
                var seekerConfiguration = getSeekerConfig(playoutData);
                var isOldWebOS = isOldWebOs();
                var isLinearManifest = checkIsManifestLinearType(playoutData.type);
                var isZenterio = CoreVideoInternal.deviceType === DeviceType.Zenterio;
                // Only avoid pausing on Safari = 15 as certain player events don't fire consistently
                var pauseOnSeek = !isSafariMajorVersion(CoreVideoInternal.deviceInfo, CoreVideoInternal.deviceType, 15);
                var config = {
                    pauseOnSeek: pauseOnSeek,
                    throttleSeeking: ((_this_player_drmInfo = this.player.drmInfo()) === null || _this_player_drmInfo === void 0 ? void 0 : _this_player_drmInfo.keySystem) === 'com.microsoft.playready',
                    lowerBandwidthOnSeek: isOldWebOS && !seekerConfiguration.disableLowBandwidthOnSeek,
                    togglePlayPauseBeforeSeek: isOldWebOS && isLinearManifest,
                    togglePlayPauseAfterSeek: isOldWebOS || isZenterio,
                    safeSeek: isOldWebOS && isLinearManifest,
                    seekingStallRetryEnabled: Boolean((_this_playerConfig_seeker = this.playerConfig.seeker) === null || _this_playerConfig_seeker === void 0 ? void 0 : _this_playerConfig_seeker.seekingStallRetryEnabled)
                };
                this.seeker = new ShakaPlayerEngineSeeker(playoutData.type, this.player, this.videoElement, config);
            }
        }
    ]);
    return ShakaPlayerEngineItem;
}(BasePlayerEngineItem);

//# sourceMappingURL=shaka-player-engine-item.js.map